export enum FormFields {
    FULL_NAME = 'full_name',
    EMAIL = 'email',
    ORGANIZATION_NAME = 'organization.name',
    WEBSITE_URL = 'website_url',
    COMPANY_NAME = 'company.company_name',
    COMPANY_TYPE = 'company.company_type',
    PHONE_NUMBER = 'phone_number',
    REQUEST_SMS_CONSENT = 'request_sms_consent',
    ADDRESS = 'address',
    JOB_TITLE = 'job_title',
    NOTES = 'notes',
    ERROR_BANNER_MESSAGE = 'error_banner_message',
    CUSTOM_CONTACT_FIELDS = 'custom_contact_fields',
    INDUSTRY = 'industry',
    FOUNDED = 'founded',
    COMPANY_SIZE = 'company_size',
    LINKEDIN_BUSINESS = 'linkedin_business',
    LINKEDIN_PERSONAL = 'linkedin_personal',
    INSTAGRAM = 'instagram',
    TWITTER = 'twitter',
    FACEBOOK = 'facebook',
    SPECIALTIES = 'specialties',
    INTERACTION_DATE = 'interaction_date'
}

export enum OrganizationFields {
    ORGANIZATION = 'organization',
    ORGANIZATION_NAME = 'name'
}

export enum CompanyFields {
    COMPANY = 'company',
    COMPANY_NAME = 'company_name',
    COMPANY_TYPE = 'company_type'
}
